import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ModalModule } from 'ngx-bootstrap/modal';
import { ToastrModule } from 'ngx-toastr';
import { NgxUiLoaderModule } from 'ngx-ui-loader';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { DefaultLayoutComponent } from './containers';
import { LoginComponent } from './modules/auth/components/login/login.component';
import { CoreModule } from './modules/core/core.module';
import { CustomFormFieldService } from './modules/shared/services/form-field.service';
import { NgSelectModule } from '@ng-select/ng-select';
import { CommonModule, DatePipe, DecimalPipe } from '@angular/common';
import { RoleSelectionComponent } from './modules/auth/modals/role-selection/role-selection.component';
import { CountdownModule } from 'ngx-countdown';
import { TagInputModule } from 'ngx-chips';
import { MatSliderModule } from '@angular/material/slider';
import {MatCheckboxModule} from '@angular/material/checkbox';
import { UnregisteredComponent } from './modules/unregistered/unregistered.component';
import { AccordionModule } from 'ngx-bootstrap/accordion';
import {MatChipsModule} from '@angular/material/chips';
import { MatIconModule } from '@angular/material/icon';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { UnregisteredVendorNegotiationComponent } from './unregistered-vendor-negotiation/unregistered-vendor-negotiation.component';
@NgModule({
  declarations: [
    AppComponent,
    DefaultLayoutComponent,
    RoleSelectionComponent,
    LoginComponent,
    UnregisteredComponent,
    UnregisteredVendorNegotiationComponent
  ],
  imports: [
    AccordionModule.forRoot(),
    BrowserModule,
    MatCheckboxModule,
    MatIconModule,
    MatChipsModule,
    MatFormFieldModule,
    MatInputModule,
    CoreModule,
    MatSliderModule,
    NgxUiLoaderModule.forRoot({
      overlayColor: '#a9bdc56e',
      fgsColor: '#0098A6',
      pbColor: '#ffffff'
    }),
    ToastrModule.forRoot({
      timeOut: 5000,
      positionClass: 'toast-top-right',
      preventDuplicates: true,
      closeButton: true,
      iconClasses: {
        success: 'toast-success',
        error: 'toast-error',
        warning: 'toast-warning',
      }
    }),
    FormsModule,
    ReactiveFormsModule,
    ModalModule.forRoot(),
    AppRoutingModule,
    NgSelectModule,
    CommonModule,
    BrowserAnimationsModule,
    CountdownModule,
    TagInputModule
  ],
  providers: [ CustomFormFieldService, DatePipe,DecimalPipe ],
  bootstrap: [ AppComponent ]
})
export class AppModule { }
